import { useState } from "react";
import { toast } from "sonner";
import { Receipt, Loader2 } from "lucide-react";
import { createBill, invoicePdfUrl } from "@/lib/api";

/** One click: bill any payment on a consult/sale that has no bill yet (one bill per payment,
 *  emailed to the member), then open the latest. Payments are also billed automatically a few
 *  minutes after they're recorded. A consult and its All Sales row share their bills. */
export default function BillButton({ kind, id, billed, onBilled }) {
  const [busy, setBusy] = useState(false);
  const click = async () => {
    // Open the tab synchronously so the browser doesn't treat it as a pop-up.
    const tab = window.open("", "_blank");
    setBusy(true);
    try {
      const r = await createBill(kind, id);
      const inv = r.invoice;
      if (tab) tab.location.href = invoicePdfUrl(inv.id);
      if (r.created) {
        const what = (r.issued?.length || 0) > 1 ? `${r.issued.length} bills (${r.issued.join(", ")})` : `Bill ${inv.number}`;
        if (r.email?.sent) toast.success(`${what} emailed to ${r.email.to}`);
        else toast.success(`${what} created`, { description: r.email?.reason });
        onBilled && onBilled(inv);
      } else {
        toast(`Opened bill ${inv.number}`);
      }
    } catch (e) {
      if (tab) tab.close();
      toast.error(e?.response?.data?.detail || "Couldn't create the bill");
    } finally {
      setBusy(false);
    }
  };
  return (
    <button
      onClick={click}
      disabled={busy}
      className={`p-1 transition-colors ${billed ? "text-emerald-400 hover:text-emerald-300" : "text-zinc-500 hover:text-amber-300"}`}
      title={billed ? "Bills raised — open the latest" : "Generate bill (emails the member)"}
      aria-label={billed ? "Open bill" : "Generate bill"}
      data-testid={`bill-${kind}-${id}`}
    >
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Receipt className="h-3.5 w-3.5" />}
    </button>
  );
}
